import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEU from 'moment/locale/eu'
import setting from './en-US/setting'

const components = {
  antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  'message': '-',

  ...components,
  ...setting,
  '最大客服人员数': 'Maximum number of customer service personnel',
  '草稿': 'draft',
  '微信支付': 'WeChat payment',
  '请输入客服名称': 'Please enter the customer service name',
  '头像链接': 'Avatar link',
  '发送描述': 'Send Description',
  '已强退': 'Forced withdrawal',
  '评论时间': 'Comment time',
  '排序不能为空': 'Sorting cannot be empty',
  '物理类型': 'Physical type',
  '价格': 'price',
  '是否激活': 'Is it activated',
  '购买商品次数': 'Purchase frequency of goods',
  '首件': 'First piece',
  '举报时间': 'Reporting time',
  '商户私钥': 'Merchant private key',
  '访问编号': 'Access number',
  '被举报人昵称': 'Nickname of the whistleblower',
  '审核状态': 'Review status',
  '请选择上级分类': 'Please select a superior classification',
  '签名': 'autograph',
  '请选择选择开启状态': 'Please select the enabled state',
  '请选择渠道编码': 'Please select channel code',
  '单规格': 'Single specification',
  '停用': 'Deactivate',
  '请输入生成功能名': 'Please enter the name of the generation function',
  '支付渠道': 'Payment channels',
  '规格名称': 'form name',
  '话题': 'topic',
  '模板名称': 'Template Name',
  '模板编号': 'Template number',
  '删除': 'delete',
  '使用次数': 'Usage frequency',
  '刷新缓存': 'Refresh cache',
  '菜单名称不能为空': 'The menu name cannot be empty',
  '主机': 'main engine',
  '分销商升级方式': 'Distributor upgrade method',
  '请输入渠道编码': 'Please enter the channel code',
  '字段名称': 'Field Name',
  '请输入调用目标字符串': 'Please enter the call target string',
  '处理反馈': 'Handling feedback',
  '新增成功': 'New successfully added',
  '请输入短信模板名称': 'Please enter the name of the SMS template',
  '服务最大人数': 'Maximum number of people served',
  '字典名称不能为空': 'Dictionary name cannot be empty',
  '模版编码不能为空': 'Template code cannot be empty',
  '所属分类名称': 'Classification Name',
  '举报原因': 'Reason for reporting',
  '登录地址': 'Login address',
  '商品图片': 'Product images',
  '发送邮箱密码': 'Send email password',
  '查询': 'query',
  '请输入脱敏起始位置': 'Please enter the starting position for desensitization',
  '岗位编码': 'Job code',
  '用户状态': 'User status',
  '指定包邮': 'Designated free shipping',
  '审核信息': 'Review information',
  '参数键值': 'Parameter key values',
  '导入设备': 'Import device',
  '轮播内容': 'Rotating content',
  '请输入数据库密码': 'Please enter the database password',
  '确认密码': 'Confirm password',
  '更多': 'more',
  '支付宝支付': 'Alipay payment',
  '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头': "The routing address to be accessed, such as' user '. If an external network address requires internal chain access, it starts with' http (s)://'",
  '一级': 'First level',
  '请输入手机号': 'Please enter your phone number',
  '启用状态': 'Enabling status',
  '资讯内容': 'Information content',
  '电子邮件': 'Email',
  '规格属性': 'Specification attributes',
  '本地邮件': 'Local Mail',
  '显示排序': 'Display sorting',
  '配送区域及运费': 'Distribution area and shipping cost',
  '公钥模式': 'Public key mode',
  '上传级别背景图片': 'Upload level background image',
  '任务状态': 'Task status',
  '列展示/排序': 'Column display/sorting',
  '商品分类': 'Product classification',
  '收藏数': 'Number of Collections',
  '审核': 'Auditing',
  '数据标签不能为空': 'The data label cannot be empty',
  '图标': 'icon',
  '多规格': 'Multiple specifications',
  '密码不能为空': 'Password cannot be empty',
  '文章分类': 'Article classification',
  '邮箱': 'mailbox',
  '上传视频': 'Upload video',
  '请选择图片': 'Please select an image',
  '同步': 'synchronization',
  '达标方式': 'Compliance methods',
  '证书序列号': 'Certificate serial number',
  '生成': 'generate',
  '欢迎': 'welcome',
  '确定': 'confirm',
  '新增': 'New addition',
  '举报视频': 'Reporting video',
  '新增用户': 'New Users',
  '列排序需拖动名称': 'Column sorting requires dragging the name',
  '中文名称': 'Chinese name',
  '请输入字典类型': 'Please enter the dictionary type',
  '路由地址': 'Routing address',
  '菜谱所属分类': 'Classification of recipes',
  '分销总开关': 'Distribution main switch',
  '确认': 'confirm',
  '是否开启': 'Is it enabled',
  '文章图片': 'Article images',
  '公告标题不能为空': 'The announcement title cannot be empty',
  '日志信息': 'log information',
  '权限字符不能为空': 'The permission character cannot be empty',
  '请输入阿里云邮件AccessKeySecret': 'Please enter the Aliyun email Access KeySecret',
  '消费类型': 'Consumption type',
  '请输入视频链接': 'Please enter the video link',
  '设备图片': 'Device images',
  '请输入脱敏字符数': 'Please enter the number of desensitized characters',
  '发布时间': 'Release time',
  '登录信息': 'login information',
  '根证书': 'Root certificate',
  '脱敏起始位置不能为空': 'Desensitization starting position cannot be empty',
  '请输入级别名称': 'Please enter the level name',
  '天': 'day',
  '问题标题': 'Question Title',
  '菜谱视频标题': 'Recipe video title',
  '腾讯云区域ID': 'Tencent Cloud Region ID',
  '文章内容': 'Article content',
  '请选择是否推送': 'Please choose whether to push or not',
  '消耗时间': 'Consume time',
  '应用场景不能为空': 'The application scenario cannot be empty',
  '添加条件': 'Add conditions',
  '列表': 'list',
  '活动时长': 'Activity duration',
  '请输入分组名称': 'Please enter the group name',
  '服务器名称': 'Server Name',
  '脱敏起始位置': 'Desensitization starting position',
  '商户状态': 'Merchant status',
  '审核状态不能为空': 'The review status cannot be empty',
  '显示顺序': 'Display order',
  '腾讯邮件': 'Tencent Email',
  '调用目标字符串不能为空': 'The target string cannot be empty when calling',
  '邀请码': 'Invitation code',
  '商户账号': 'Merchant account',
  '路由地址不能为空': 'The routing address cannot be empty',
  '请输入搜索内容': 'Please enter search content',
  '菜谱信息': 'Recipe information',
  '发送时间': 'Sending time',
  '必填': 'Required',
  '阿里云密钥SECRET': 'Alibaba Cloud Key SECRET',
  '可配送区域': 'Deliverable area',
  '请描述您的业务使用场景': 'Please describe your business usage scenario',
  '实体类名称': 'Entity class name',
  '请上传图片': 'Please upload pictures',
  '年龄不能为空': 'Age cannot be empty',
  '请输入年龄': 'Please enter your age',
  '请输入下架原因': 'Please enter the reason for delisting',
  '共': 'common',
  '请输入运费': 'Please enter the shipping cost',
  '规格模板名称': 'Specification template name',
  '女': 'female',
  '关': 'shut',
  '活动地址': 'Event address',
  '请输入处理结果': 'Please enter the processing result',
  '举报描述': 'Report Description',
  '短信渠道': 'SMS channel',
  '查看文章': 'View articles',
  '签名名称': 'Signature Name',
  '标题': 'title',
  '取消置顶': 'Cancel Topping',
  '组件路径': 'Component path',
  '项目名称不能为空': 'Project name cannot be empty',
  '紧凑': 'compact',
  '用户导入': 'User import',
  '是否并发': 'Is it concurrent',
  '首页': 'home page',
  '详情': 'details',
  '二级': 'second level',
  '短信签名不能为空': 'SMS signature cannot be empty',
  '返回': 'return',
  '参数键值不能为空': 'The parameter key value cannot be empty',
  '重置成功': 'Reset successful',
  '请求方式': 'Request method',
  '请正确填写联系电话': 'Please fill in the contact phone number correctly',
  '评论数': 'Number of comments',
  '用量': 'dosage',
  '注册': 'register',
  '请输入序号': 'Please enter the serial number',
  '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种': 'Please enter 5-20 English letters, numbers, or symbols (excluding spaces), and at least two types of letters, numbers, and punctuation marks are required',
  '重量': 'weight',
  '树编码字段': 'Tree encoding field',
  '生成代码方式': 'Generate Code Method',
  '三级': 'Level 3',
  '计费方式': 'Billing method',
  '验证码': 'Verification code',
  '请输入商户名称': 'Please enter the merchant name',
  '短信渠道编号不能为空': 'The SMS channel number cannot be empty',
  '账户': 'account',
  '操作类型': 'Operation type',
  '预览': 'preview',
  '联系人姓名不能为空': 'Contact name cannot be empty',
  '达标选择方式': 'Standard selection method',
  '盘符类型': 'Drive letter type',
  '请输入接入域名': 'Please enter the access domain name',
  '调料': 'Seasoning',
  '请输入正确的手机号码': 'Please enter the correct phone number',
  '显示排序不能为空': 'Display sorting cannot be empty',
  '支付订单号': 'Payment order number',
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问': 'If you choose to hide, the route will not appear in the sidebar, but it can still be accessed',
  '冒充': 'Impersonation',
  '模板内容不能为空': 'The template content cannot be empty',
  '配料名称': 'Ingredients Name',
  '广告显示位置': 'Advertising display location',
  '请输入数据键值': 'Please enter the data key value',
  '的类型吗?': 'Is it of the type?',
  '展示视频': 'Display video',
  '数据库密码': 'Database password',
  '文字内容': 'Text content',
  '字典状态': 'Dictionary status',
  '会员号': 'Member ID',
  '菜谱标题': 'Recipe Title',
  '请选择计费方式': 'Please select the billing method',
  '购买礼包': 'Purchase gift package',
  '部门': 'department',
  '订单编号': 'Order number',
  '用户昵称': 'User nickname',
  '分销级别': 'Distribution level',
  '用户名': 'user name',
  '角色编号': 'Role Number',
  '请输入姓名': 'Please enter your name',
  '任务分组': 'Task grouping',
  '处理人': 'Processed by',
  '成本价': 'Cost price',
  '发送邮箱账号': 'Send email account',
  '参数键名不能为空': 'The parameter key name cannot be empty',
  '请输入实体类名称': 'Please enter the entity class name',
  '厨社区': 'Kitchen Community',
  '联系人姓名': 'Contact Name',
  '请输入数据库名称': 'Please enter the database name',
  '请输入备注': 'Please enter a note',
  '请输入腾讯云邮件SecretId': 'Please enter the Tencent Cloud email SecretId',
  '异常信息': 'Abnormal information',
  '上传失败': 'Upload failed',
  '返回参数': 'Return parameters',
  '短信渠道编码': 'SMS channel code',
  '请输入审核失败原因': 'Please enter the reason for the audit failure',
  '公告类型不能为空': 'Announcement type cannot be empty',
  '规格值': 'Specification value',
  '昵称': 'nickname',
  '审核类型': 'Audit type',
  '分配角色': 'Assign Roles',
  '上传': 'upload',
  '支付状态': 'Payment status',
  '请输入系统模块': 'Please enter the system module',
  '任务组名': 'Task group name',
  '请获取支付宝公钥字符串': 'Please obtain Alipay public key string',
  '请选择执行状态': 'Please select the execution status',
  '审核失败原因': 'Reason for audit failure',
  '参数名称': 'Parameter Name',
  '内存': 'Memory',
  '接收时间': 'Receiving time',
  '类型': 'type',
  '请输入列名描述': 'Please enter a column name description',
  '执行时间': 'execution time',
  '浏览器': 'browser',
  '活动内容': 'Activity content',
  '请输入作者': 'Please enter the author',
  '生成业务包名': 'Generate Business Package Name',
  '登录状态': 'Login status',
  '只能输入字母或数字': 'Only letters or numbers can be entered',
  '联系电话': 'Contact phone number',
  '字段描述': 'Field Description',
  '全选/全不选': 'Select All/Select None',
  '请正确填写邮箱地址': 'Please fill in your email address correctly',
  '联系人电话': 'Contact phone number',
  '图文封面': 'Image and text cover',
  '请输入商户简称': "Please enter the merchant's abbreviation",
  '客服密码不能为空': 'Customer service password cannot be empty',
  '包邮件数': 'Number of package emails',
  '修改菜单': 'Modify menu',
  '分销商协议标题': 'Distributor Agreement Title',
  '运行时长': 'Run time',
  '字典编码': 'Dictionary encoding',
  '分组名称': 'Group Name',
  '任务名称不能为空': 'Task name cannot be empty',
  '例：1个': 'Example: 1',
  '标题不能为空': 'Title cannot be empty',
  '请选择分销等级': 'Please select distribution level',
  '反馈类型名称': 'Feedback type name',
  '已用百分比': 'Used percentage',
  '消费金额': 'Consumption amount',
  '请再次输入新密码确认': 'Please enter the new password again to confirm',
  '中等': 'secondary',
  '操作系统': 'operating system',
  '大图': 'Large image',
  '请输入注销原因': 'Please enter the reason for cancellation',
  '请输入数据库端口': 'Please enter the database port',
  '修改角色': 'Modify Role',
  '操作模块': 'Operation module',
  '记录日期': 'Record date',
  '关闭': 'close',
  '客户端数': 'Number of clients',
  '调料名称': 'Seasoning name',
  '请选择生成模板': 'Please select a generation template',
  '视频标题': 'Video Title',
  '内容': 'content',
  '添加角色': 'Add Role',
  '未置顶': 'Unplaced',
  '腾讯云密钥SECRET': 'Tencent Cloud Key SECRET',
  '数据键值': 'Data key value',
  '用户昵称不能为空': 'User nickname cannot be empty',
  '封面图': 'Cover image',
  '角色': 'role',
  '请输入续费': 'Please enter renewal',
  '角色名称': 'Role Name',
  '添加菜单': 'add menu',
  '修改': 'modify',
  '下架': 'Remove from shelves',
  '图片': 'picture',
  '分组名称不能为空': 'Group name cannot be empty',
  '骚扰': 'harass',
  '直邀等级数量': 'Number of direct invitation levels',
  '被举报用户名称': 'Reported user name',
  '修改成功': 'Modified successfully',
  '佣金发放模式': 'Commission payment mode',
  '数据库用户名': 'Database username',
  '请求参数': 'Request parameters',
  '通知': 'notice',
  '添加字典类型': 'Add Dictionary Type',
  '模板编码不能为空': 'The template code cannot be empty',
  '举报证据': 'Reporting evidence',
  '系统模块': 'System modules',
  '退款成功时间': 'Refund successful time',
  '分配用户': 'Assign Users',
  '填写审核意见': 'Fill in review comments',
  '编辑': 'edit',
  '字典排序': 'Dictionary sorting',
  '暂不处理': 'Not to be processed temporarily',
  '用户名不能为空': 'The username cannot be empty',
  '可用大小': 'Available sizes',
  '直接购买身份': 'Direct purchase of identity',
  '插入时间': 'Insertion time',
  '生成功能名': 'Generate Function Name',
  '请输入订单编号': 'Please enter the order number',
  '客服名称': 'Customer service name',
  '团队销售额': 'Team sales',
  '请输入头像链接': 'Please enter the avatar link',
  '关联信息': 'Related information',
  '菜谱内容': 'Recipe content',
  '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致，仅在多页签下有效。': "If you choose Yes, it will be cached by 'keep alive', and the 'name' and address of the matching component need to be consistent, only valid in multi page tabs.",
  '是否显示': 'Is it displayed',
  '取消授权': 'Cancel authorization',
  '当勾选项为空时方可切换模式，可以点击”全不选“后再次切换。': "When the checkbox is empty, you can switch modes. You can click 'uncheck all' and then switch again.",
  '上传图片': 'Upload images',
  '请输入模板编号': 'Please enter the template number',
  '活动状态': 'Activity status',
  '视频内容': 'Video content',
  '手机号不能为空': 'Phone number cannot be empty',
  '请输入帐户名': 'Please enter your account name',
  '部门名称不能为空': 'Department name cannot be empty',
  '脱敏字符数不能为空': 'The number of desensitized characters cannot be empty',
  '父子联动': 'Father son linkage',
  '团队等级数量': 'Number of team levels',
  '账号': 'Account',
  '请输入项目名称': 'Please enter the project name',
  '查看商品': 'View products',
  '添加部门': 'Add Department',
  '给自己起个名字': 'Give yourself a name',
  '处理': 'handle',
  '上传文件': 'Upload files',
  '添加参数': 'Add parameters',
  '待审核': 'Pending review',
  '添加用户': 'Add user',
  '商户名称不能为空': 'Merchant name cannot be empty',
  '浏览数': 'Number of views',
  '身份证号': 'ID number',
  '访问的组件路径，如：`system/user/index`，默认在`views`目录下': "The path to the accessed component, such as' system/user/index ', defaults to the' views' directory",
  '请输入模板名称': 'Please enter the template name',
  '商户简称': 'Merchant abbreviation',
  '数据顺序不能为空': 'The data order cannot be empty',
  '岗位编码不能为空': 'The position code cannot be empty',
  '修改部门': 'Modify department',
  '请输入数据库用户名': 'Please enter the database username',
  '文章标题不能为空': 'The article title cannot be empty',
  '请获取商户私钥': "Please obtain the merchant's private key",
  '联系电话不能为空': 'Contact number cannot be empty',
  '请输入联系人姓名': "Please enter the contact person's name",
  '字段列名': 'Field column names',
  '条件': 'condition',
  '修改用户': 'Modify Users',
  '请输入排序': 'Please enter sorting',
  '请输入腾讯云邮件SecretKey': 'Please enter the Tencent Cloud email SecretKey',
  '消息内容': 'Message content',
  '支付宝公钥字符串': 'Alipay public key string',
  '禁用': 'Disabled',
  '已用大小': 'Used size',
  '上传成功': 'Upload successful',
  '点赞': 'Like',
  '资讯标题': 'Information Title',
  '重置密码': 'reset password',
  '缓存名称': 'Cache Name',
  '列名描述': 'Column Name Description',
  '步骤': 'step',
  '主料名称': 'Main material name',
  '视频类型': 'Video type',
  '分类图片': 'Classify images',
  '字典标签': 'Dictionary labels',
  '所属分类': 'Classification',
  '修改参数': 'modify parameters',
  '调用方法': 'Calling methods',
  '树父编码字段': 'Tree parent code field',
  '是否确认导出?': 'Are you sure to export?',
  '是否脱敏': 'Is it desensitized',
  '权限字符': 'Permission Characters',
  '辅料名称': 'Auxiliary material name',
  '点赞数': 'Like count',
  '回调时间': 'Callback time',
  '请输入密码': 'Please enter password',
  '请输入联系电话': 'Please enter the contact phone number',
  '模板类型不能为空': 'The template type cannot be empty',
  '数据库端口': 'Database Port',
  '请输入表描述': 'Please enter a table description',
  '公告标题': 'Announcement Title',
  '请选择商品分类': 'Please select product category',
  '状态': 'state',
  '请输入联系人电话': 'Please enter the contact phone number',
  '添加': 'Add',
  '任务编号': 'Task number',
  '支付宝公钥证书': 'Alipay public key certificate',
  '初始内容': 'Initial content',
  '分销商协议内容': 'Content of distributor agreement',
  '配料信息': 'Ingredients information',
  '请选择性别': 'Please select gender',
  '菜谱名称': 'Recipe Name',
  '处理结果': 'Processing results',
  '可以省略，省略后默认为邮箱账号smtp.邮箱后缀,例如：邮箱账号为：zbtech@163.com，smtp为smtp.163.com': 'It can be omitted. If omitted, it defaults to the email account smtp. Email suffix, for example: Email account is: zbtech@163.com SMTP is SMTP.163.3com',
  '活动标题': 'Activity Title',
  '邮件': 'mail',
  '点击量': 'Click through volume',
  '添加公告': 'Add Announcement',
  '脱敏方向不能为空': 'Desensitization direction cannot be empty',
  '请输入生成包路径': 'Please enter the path to generate the package',
  '操作': 'operation',
  '作者': 'author',
  '操作时间': 'Operation time',
  '动态图片': 'Dynamic images',
  '请输入内容': 'Please enter the content',
  '否': 'no',
  '请选择': 'Please select',
  '手机不能为空': 'Phone cannot be empty',
  '问题简述': 'Problem description',
  '其他': 'other',
  '请输入短信签名': 'Please enter your SMS signature',
  '任务名称': 'Task Name',
  '请输入联系人': 'Please enter the contact person',
  '本地视频': 'Local video',
  '请选择短信渠道编号': 'Please select the SMS channel number',
  '客服头像': 'Customer service avatar',
  '级别名称': 'Level Name',
  '请选择规格': 'Please select a specification',
  '总大小': 'Total size',
  '修改岗位': 'Modify position',
  '活跃用户': 'Active users',
  '选择是外链则路由地址需要以`http(s)://`开头': "If selecting an external link, the routing address needs to start with 'http (s)://'",
  '刷新成功': 'Refresh successful',
  '上传标识图片': 'Upload identification image',
  '请输入生成模块名': 'Please enter the name of the generation module',
  '要脱敏的列名不能为空': 'The column name to be desensitized cannot be empty',
  '级别背景': 'Level background',
  '评论内容': 'Comment content',
  '发布': 'release',
  '使用内存': 'Using memory',
  '请输入昵称': 'Please enter your nickname',
  '标签': 'label',
  '商品规格': 'Product specifications',
  '执行一次': 'Execute once',
  '模板编号不能为空': 'The template number cannot be empty',
  '邮箱不能为空': 'Email cannot be empty',
  '系统架构': 'system architecture',
  '离线': 'off-line',
  '请输入支付宝公钥字': 'Please enter Alipay public key word',
  '添加级别': 'Add level',
  '佣金发放比例': 'Commission payout ratio',
  '请输入支付宝公钥字符串': 'Please enter Alipay public key string',
  '安全设置': 'security setting',
  '订单号': 'Order number',
  '最后登录时间': 'Last login time',
  '联系人手机号不能为空': 'Contact phone number cannot be empty',
  '脱敏方向': 'Desensitization direction',
  '数据权限': 'Data permissions',
  '请输入': 'Please enter',
  '参数分组': 'Parameter grouping',
  '取消': 'cancel',
  '请输入数据标签': 'Please enter the data label',
  '模板编码': 'Template encoding',
  '系统内置': 'Built in system',
  '举报图片': 'Report images',
  '文章名称': 'Article Name',
  '客服名称不能为空': 'Customer service name cannot be empty',
  '查询方式': 'Query method',
  '数据库名称': 'Database Name',
  '银行卡号': 'Bank card number',
  '上级分类': 'Category parent',
  '文件系统': 'file system',
  '昵称不能为空': 'Nickname cannot be empty',
  '姓名': 'name',
  '标识': 'identification',
  '在线': 'on line',
  '接口信息': 'Interface information',
  '执行策略': 'Execution strategy',
  '阿里云邮件密匙ID': 'Alibaba Cloud email key ID',
  '错误策略': 'Wrong strategy',
  '盘符路径': 'Drive letter path',
  '旧密码': 'Old password',
  '生日': 'birthday',
  '驳回原因': 'Reason for rejection',
  '更新时间': 'Update time',
  '已发布': 'Published',
  '参数键名': 'Parameter key name',
  '炉头数': 'Number of furnace heads',
  '生成模板': 'Generate Template',
  '待处理': 'Pending processing',
  '模板名称不能为空': 'The template name cannot be empty',
  '请输入会员号': 'Please enter your membership number',
  '短信类型': 'SMS type',
  '项目名称': 'entry name',
  '参数名称不能为空': 'The parameter name cannot be empty',
  '菜单顺序不能为空': 'The menu order cannot be empty',
  '备注': 'Remarks',
  '商户名称': 'Merchant Name',
  '请选择任务状态': 'Please select task status',
  '渠道编码不能为空': 'Channel code cannot be empty',
  '是否推送': 'Whether to push',
  '详细地址': 'Detailed address',
  '短信内容': 'SMS content',
  '岗位名称': 'Job title',
  '项目路径': 'Project Path',
  '消息标题': 'Message Title',
  '分组人数': 'Group size',
  '列名': 'Column names',
  '请输入问题标题': 'Please enter the question title',
  '销量': 'sales volume',
  '退款状态': 'Refund status',
  '请正确填写手机号': 'Please fill in your phone number correctly',
  '导入': 'Import',
  '接入域名': 'Access domain name',
  '岗位编号': 'Job ID',
  '请输入支付订单号': 'Please enter the payment order number',
  '基本设置': 'Basic Settings',
  '密码': 'password',
  '商品名称': 'Product Name',
  '上级菜单': 'Superior menu',
  '会话编号': 'Session Number',
  '取消批量授权': 'Cancel bulk authorization',
  '确认删除所选中数据?': 'Are you sure to delete the selected data?',
  '选择地区': 'Select Region',
  '操作地点': 'Operation location',
  '公告类型': 'Announcement type',
  '开启状态': 'On state',
  '字段类型': 'Field type',
  '菜单名称': 'Menu Name',
  '菜单权限': 'Menu permissions',
  '关联子表的表名': 'The table name of the associated sub table',
  '添加视频': 'Add Video',
  '清空': 'empty',
  '两次输入的密码不一致': 'The passwords entered twice are inconsistent',
  '请输入操作人员': 'Please enter the operator',
  '模板内容': 'Template content',
  '渠道编码': 'Channel code',
  '请获取根证书信息': 'Please obtain the root certificate information',
  '缓存键名': 'Cache key names',
  '商户号': 'Merchant ID',
  '请选择是否指定包邮': 'Please choose whether to specify free shipping',
  '已结束': 'Ended',
  '排序': 'sort',
  '处理状态': 'Processing status',
  '请输入商户私钥': "Please enter the merchant's private key",
  '男': 'male',
  '分组状态': 'Group status',
  '展开': 'launch',
  '操作日期': 'Operation date',
  '请输入验证码': 'Please enter the verification code',
  '权限范围': 'Scope of permissions',
  '提交订单': 'place order',
  '商户编号': 'Merchant ID',
  '请输入账号': 'Please enter your account number',
  '请输入审核人': 'Please enter the reviewer',
  '副标题': 'Subtitle',
  '报警类型': 'Alarm type',
  '三方账号': 'Third party account',
  '请输入生成业务包名': 'Please enter the name of the generated business package',
  '请上传根证书': 'Please upload the root certificate',
  '请选择身份': 'Please select an identity',
  '最大客服分组数': 'Maximum number of customer service groups',
  '导出': 'export',
  '负责人': 'Responsible person',
  '安装路径': 'Installation path',
  '注销原因': 'Reason for cancellation',
  '联系人': 'contacts',
  '申请时间': 'Application time',
  '审核人': 'Reviewer',
  '超级管理员角色信息 不可更改': 'Super administrator role information cannot be changed',
  '部门不能为空': 'Department cannot be empty',
  '举报人昵称': "Whistleblower's nickname",
  '请输入客服密码': 'Please enter the customer service password',
  '请填写手机号邮箱': 'Please fill in your phone number and email address',
  '座机号': 'Landline number',
  '商品主图': 'Product main image',
  '分享数': 'Number of shares',
  '结束时间': 'End time',
  '岗位': 'post',
  '已处理': 'Processed',
  '部门名称': 'Department Name',
  '请输入证书序列号': 'Please enter the certificate serial number',
  '注册时间': 'Registration time',
  '操作方法': 'Operation method',
  '最新评论时间': 'Latest comment time',
  '角色名称不能为空': 'Role name cannot be empty',
  '续件': 'Continuation',
  '请上传视频缩略图': 'Please upload a video thumbnail',
  '添加配送区域': 'Add delivery area',
  '评论列表': 'Comment List',
  '模板类型': 'Template type',
  '字典类型不能为空': 'Dictionary type cannot be empty',
  '难易程度': 'Difficulty level',
  '子评论数': 'Number of sub comments',
  '图片只能上传jpg/jpeg/png文件': 'Images can only be uploaded to jpg/jpeg/png files',
  '用户邮箱': 'User email',
  '请上传视频': 'Please upload a video',
  '请确认密码': 'Please confirm password',
  '不通过原因': 'Reason for failure',
  '请输入腾讯云邮件RegionId': 'Please enter Tencent Cloud email RegionId',
  '请输入邀请码': 'Please enter the invitation code',
  '是否更新已经存在的用户数据': 'Do you want to update existing user data',
  '动态内容': 'Dynamic content',
  '联系方式': 'Contact information',
  '显示顺序不能为空': 'Display order cannot be empty',
  '发布人': 'Publisher',
  '腾讯云邮件密匙ID': 'Tencent Cloud Email Key ID',
  '操作成功 !': 'Operation successful!',
  '字典类型': 'Dictionary type',
  '创建时间': 'Creation time',
  '上级部门': 'Superior department',
  '请选择渠道': 'Please select a channel',
  '请输入商户号': 'Please enter the merchant number',
  '配料': 'batching',
  '权限标识': 'Permission identification',
  '通过': 'adopt',
  '未通过': 'Not passed',
  '运行参数': 'Operating parameters',
  '规格名': 'Specification name',
  '万': 'ten thousand',
  '请输入用户个性签名': "Please enter the user's personalized signature",
  '请输入邮箱': 'Please enter your email address',
  '登录地点': 'Login location',
  '请添加配送区域': 'Please add delivery area',
  '生成表达式': 'Generate expression',
  '菜单类型': 'Menu Type',
  '所属分组': 'Group to which it belongs',
  '要脱敏的列名': 'List to be desensitized',
  '地址': 'address',
  '操作信息': 'Operation information',
  '发送状态': 'Sending status',
  '侵权': 'tort',
  '请输入分销商协议内容': 'Please enter the content of the distributor agreement',
  '开启状态不能为空': 'The open status cannot be empty',
  '回调状态': 'Callback status',
  '证书模式': 'Certificate Mode',
  '是': 'yes',
  '模板描述': 'Template Description',
  '公告编号': 'Announcement number',
  '请输入订单号': 'Please enter the order number',
  '账户描述': 'Account Description',
  '联系人不能为空': 'Contact person cannot be empty',
  '选择图标': 'Select icon',
  '手机': 'mobile phone',
  '开始时间': 'start time',
  '删除成功': 'Delete successful',
  '应用场景': 'Application scenarios',
  '操作人员': 'Operators',
  '副标题不能为空': 'Subtitle cannot be empty',
  '请输入模板内容': 'Please enter the template content',
  '进行中': 'In progress',
  '请获取商户私钥证书': "Please obtain the merchant's private key certificate",
  "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)": "The permission characters defined in the controller, such as @ PreAuthorize (` @ ss. hasPermi ('system: user: list ') `)",
  '起始位置': 'Starting position',
  '脱敏字符数': 'Desensitized characters',
  '分类名称': 'Classification name',
  '请输入用户名称': 'Please enter the user name',
  '此操作将导出当前条件下所有数据而非选中数据': 'This operation will export all data under the current conditions instead of the selected data',
  '组件路径不能为空': 'The component path cannot be empty',
  '表描述': 'Table Description',
  '佣金返利': 'Commission rebate',
  '脱敏权限': 'Desensitization permission',
  '注销时间': 'Cancellation time',
  '登录名称': 'logon name',
  '日志编号': 'Log number',
  '显示类型': 'Display type',
  '分类名称不能为空': 'Classification name cannot be empty',
  '生成业务名': 'Generate Business Name',
  '请选择任务组名': 'Please select a task group name',
  '动态标题': 'Dynamic Title',
  '展示图片': 'Display images',
  '字典名称': 'Dictionary Name',
  '生成包路径': 'Generate package path',
  '下次执行时间': 'Next execution time',
  '请输入要脱敏的列名': 'Please enter the column name to be desensitized',
  '设备编号': 'Equipment number',
  '请输入阿里云邮件AccessKeyId': 'Please enter the Alibaba Cloud email Access KeyId',
  '选择停用则路由将不会出现在侧边栏，也不能被访问': 'If you choose to disable, the route will not appear in the sidebar and cannot be accessed',
  '审核时间': 'Review time',
  '用户个性签名': 'User personalized signature',
  '单位': 'unit',
  '设备名称': 'Device Name',
  '修改字典类型': 'Modify Dictionary Type',
  '列名描述不能为空': 'Column name description cannot be empty',
  '菜谱描述': 'Recipe Description',
  '姓名不能为空': 'Name cannot be empty',
  '日志': 'journal',
  '日志序号': 'Log Number',
  '活动时间': 'Activity time',
  '签名名称不能为空': 'The signature name cannot be empty',
  '字典编号': 'Dictionary number',
  '辅料': 'accessories',
  '客服工作台': 'Customer service workbench',
  '请输入阿里云邮件RegionId': 'Please enter the Alibaba Cloud email RegionId',
  '账号有效期': 'Account validity period',
  '收货人电话': "Recipient's phone number",
  '请选择文章分类': 'Please select the article category',
  '时间': 'time',
  '阿里邮件': 'Alibaba Mail',
  '请输入级别描述': 'Please enter a level description',
  '主料': 'Main materials',
  '请输入任务名称': 'Please enter the task name',
  '使用状态': 'Usage status',
  '客服标识': 'Customer service identification',
  '添加时间': 'Add time',
  '请输入旧密码': 'Please enter your old password',
  '短信类型不能为空': 'SMS type cannot be empty',
  '缩略图': 'thumbnail',
  '问题内容': 'Problem content',
  '话题标题': 'Topic Title',
  '客服密码': 'Customer service password',
  '执行成功': 'Execution successful',
  '启用': 'Enable',
  '分销商级别': 'Distributor level',
  '级别标识': 'Level identification',
  '置顶': 'Topping',
  '端口': 'port',
  '高级': 'senior',
  '渠道费率': 'Channel rate',
  '商品标题': 'Product title',
  '举报人账号': "Reporting person's account",
  '设备封面图': 'Equipment Cover Picture',
  '规格': 'specifications',
  '请至少添加一个地区': 'Please add at least one region',
  '数据键值不能为空': 'The data key value cannot be empty',
  '性别': 'Gender',
  '手机号': 'Mobile phone number',
  '做法步骤': 'Procedure steps',
  '其他信息': 'Other information',
  '添加/编辑': 'Add/Edit',
  '阿里云区域ID': 'Alibaba Cloud Regional ID',
  '上架状态': 'Listing status',
  '未开始': 'Not started yet',
  '是否允许评论': 'Allow comments',
  '签名与模板': 'Signature and Template',
  '开': 'open',
  '请输入邮箱smtp': 'Please enter the email smtp',
  '是否缓存': 'Is it cached',
  '内存配置': 'Memory configuration',
  '是否外链': 'Is it an external link',
  '请选择用户状态': 'Please select user status',
  '商品详情': 'Product details',
  '请填写手机号': 'Please fill in your phone number',
  '请获取商户公钥应用证书': "Please obtain the merchant's public key application certificate",
  '收起': 'Put it away',
  '反馈内容': 'Feedback content',
  '保存': 'preserve',
  '添加指定包邮区域': 'Add specified free shipping area',
  '生效状态': 'Effective status',
  '树名称字段': 'Tree name field',
  '手动申请审核': 'Manual application review',
  '扩展号': 'Extension number',
  '收货人姓名': 'Consignee Name',
  '评论人': 'Reviewer',
  '添加岗位': 'Add position',
  '邮箱账号不能为空': 'Email account cannot be empty',
  '缓存内容': 'Caching content',
  '服务商': 'Service providers',
  '新密码': 'New password',
  '分销设置': 'Distribution settings',
  '接收状态': 'Receiving status',
  '账户密码': 'Account password',
  '请选择审核状态': 'Please select the review status',
  '基本信息': 'Basic information',
  '库存': 'inventory',
  '原价': 'Original price',
  '用户编号': 'User ID',
  '支付时间': 'Payment time',
  '登陆时间': 'Login time',
  '登录时间': 'login time',
  '角色名': 'Role Name',
  '请求地址': 'Request address',
  '请获取支付宝公钥证书': 'Please obtain Alipay public key certificate',
  '浏览量': 'View volume',
  '最大服务人数': 'Maximum number of service personnel',
  '参数类型': 'Parameter type',
  '上级部门不能为空': 'Superior department cannot be empty',
  '邮箱密码不能为空': 'Email password cannot be empty',
  '序号': 'Number',
  '请输入标题': 'Please enter a title',
  '手机号码': 'Mobile phone number',
  '字典键值': 'Dictionary key values',
  '发送邮箱smtp': 'Send email SMTP',
  '数据标签': 'Data labels',
  '请输入菜谱描述': 'Please enter a recipe description',
  '启动时间': 'Start time',
  '岗位名称不能为空': 'The position name cannot be empty',
  '重置': 'Reset',
  '执行状态': 'Execution status',
  '短信签名': 'SMS signature',
  '普通': 'ordinary',
  '是否置顶': 'Whether to place at the top',
  '条': 'strip',
  '注销原因不能为空': 'The reason for cancellation cannot be empty',
  '提示': 'prompt',
  '图片裁切': 'Image cropping',
  '请输入模板编码': 'Please enter the template code',
  '在线状态': 'Online status',
  '取消审核': 'Cancel review',
  '用户名称': 'User Name',
  '解锁': 'Unlock',
  '接入域名不能为空': 'Access domain name cannot be empty',
  '操作状态': 'Operation status',
  '规格名称不能为空': 'Specification name cannot be empty',
  '调用目标字符串': 'Call target string',
  '实体': 'entity',
  '请输入新密码': 'Please enter a new password',
  '请输入分销商协议标题': 'Please enter the distributor agreement title',
  '属性': 'attribute',
  '售价': 'price',
  '请获取商户公钥字符串': "Please obtain the merchant's public key string",
  '申请信息': 'Application Information',
  '请输入文章内容': 'Please enter the content of the article',
  '市场价格': 'market price',
  '是否前置组': 'Is it a pre group',
  '生成模块名': 'Generate Module Name',
  '视频': 'video',
  '账户信息': 'Account information',
  '年龄': 'Age',
  '伪冒': 'Counterfeiting',
  '公钥类型': 'Public key type',
  '请输入最大服务人数': 'Please enter the maximum number of service personnel',
  '请输入渠道费率': 'Please enter the channel rate',
  '编号': 'number',
  '详细': 'detailed',
  ',其他文件请直接上传': 'Please upload other files directly',
  '点击展开更多': 'Click to expand more',
  '级别描述': 'Level Description',
  '子表关联的外键名': 'Foreign key names associated with sub tables',
  '确定注销并退出系统吗?': 'Are you sure to log out and exit the system?',
  '请输入表名称': 'Please enter the table name',
  '请输入字典名称': 'Please enter the dictionary name',
  '商品图册': 'Product brochure',
  '请上传封面图': 'Please upload the cover image',
  '请输入登录地址': 'Please enter your login address',
  '反馈图片': 'Feedback image',
  '客服状态': 'Customer service status',
  '展开/折叠': 'Expand/Fold',
  '请选择状态': 'Please select a status',
  '设为默认签名': 'Set as default signature',
  '被举报账号': 'Reported account',
  '简单': 'simple',
  '视频链接': 'Video link',
  '诈骗': 'Fraud',
  '默认': 'default',
  '插入': 'insert',
  '表名称': 'Table Name',
  '角色标识': 'Role identification',
  '商户公钥应用证书': 'Merchant Public Key Application Certificate',
  '运行模式': 'Operation mode',
  '请输入仓库名称': 'Please enter the warehouse name',
  '请输入正确的邮箱地址': 'Please enter the correct email address',
  '请选择系统菜单': 'Please select the system menu',
  '账号不能为空': 'Account cannot be empty',
  '请输入生成业务名': 'Please enter the generated business name',
  '调用目标方法': 'Calling the target method',
  '是否前置分组': 'Whether to pre group',
  '返回生成页': 'Return to generation page',
  '商品类型': 'Product type',
  '申请分销身份': 'Applying for distribution identity',
  '被举报人账号': "Reported person's account",
  '退出登录': 'Logout',
  '个人设置': 'Personal settings',
  '当前密码强度': 'Current password strength',
  '强': 'strong',
  '是否推荐': 'Do you recommend it',
  '取消推荐': 'Cancel recommendation',
  '推荐': 'recommendation',
  '未推荐': 'Not recommended',
  '已推荐': 'Recommended',
  '动态列表': 'Dynamic List',
  '是': 'yes',
  '否': 'no',
  '缓存': 'cache',
  '不缓存': 'Do not cache',
  '按钮': 'button',
  '菜单': 'menu',
  '目录': 'catalog',
  '富文本': 'Rich Text',
  '文本框': 'Text box',
  '输入框': 'Input box',
  '回复': 'reply',
  '故障内容': 'Fault content',
  '故障代码': 'Fault code',
  '炉头': 'Furnace head',
  '导出上传模板': 'Export upload template'
}
